/**
 * Утилита для редиректа в ВК приложение Про100 Квиз
 * Используется для перехода к приложению с указанием group_id
 */

const VK_BASE_URL = 'https://vk.com/'
const VK_APP_ID = 'app54506386'

/**
 * Получение group_id (заглушка)
 * В будущем здесь будет запрос к API с использованием city_title
 * @param {string} cityTitle - название города (пока не используется)
 * @returns {string} group_id
 */
export function getGroupId(cityTitle = '') {
  console.log('[vkRedirect] getGroupId: вызов с cityTitle =', cityTitle);
  // Заглушка - возвращаем фиксированный ID независимо от города
  // В будущем здесь будет запрос к API с использованием cityTitle
  const groupId = '222149670'
  console.log('[vkRedirect] getGroupId: возвращаем (заглушка)', groupId);
  return groupId
}

/**
 * Формирование URL для перехода в ВК приложение
 * @param {string} groupId - ID группы (по умолчанию используется заглушка)
 * @returns {string} полный URL
 */
export function getVkAppUrl(groupId = null) {
  console.log('[vkRedirect] getVkAppUrl: вызов с groupId =', groupId);
  const id = groupId || getGroupId()
  const url = `${VK_BASE_URL}${VK_APP_ID}#group_id=${id}`
  console.log('[vkRedirect] getVkAppUrl: сформированный URL =', url);
  return url
}

/**
 * Редирект в ВК приложение
 * @param {Object} options - опции редиректа
 * @param {string} options.cityTitle - название города (для получения group_id)
 * @param {string} options.groupId - конкретный group_id (если известен)
 * @param {boolean} options.newWindow - открывать в новом окне (true) или в текущем (false)
 * @param {string} options.target - альтернативный способ указания цели ('_blank', '_self', и т.д.)
 */
export function redirectToVkApp(options = {}) {
  console.log('[vkRedirect] redirectToVkApp: ВЫЗОВ функции с опциями', options);
  const {
    cityTitle = '',
    groupId = null,
    newWindow = true,
    target = null
  } = options

  const url = getVkAppUrl(groupId || getGroupId(cityTitle))
  console.log('[vkRedirect] redirectToVkApp: итоговый URL для перехода =', url);

  // Определяем цель открытия
  const openTarget = target || (newWindow ? '_blank' : '_self')
  console.log('[vkRedirect] redirectToVkApp: цель открытия =', openTarget);

  if (openTarget === '_blank') {
    console.log('[vkRedirect] redirectToVkApp: открытие в НОВОМ окне через window.open');
    window.open(url, '_blank')
  } else {
    console.log('[vkRedirect] redirectToVkApp: переход в ТЕКУЩЕМ окне через window.location.href');
    window.location.href = url
  }

  console.log('[vkRedirect] redirectToVkApp: редирект ВЫПОЛНЕН');
  return url
}

export default {
  getGroupId,
  getVkAppUrl,
  redirectToVkApp
}
